import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'protectedName'
})
export class ProtectedNamePipe implements PipeTransform {

  userType = localStorage.getItem('type');
  isManager = localStorage.getItem('isManager');
  loggedInUserid = localStorage.getItem('residents');

  transform(name: string, { userId }: { userId: string} = { userId: ''}) {
    // console.log(`userType: ${this.userType}, isManager: ${this.isManager}, name is ${name}, userId is ${userId}`);
    const sameUserLoggedIn = this.loggedInUserid === userId;
    let result = '';
    if (!!name) {
      result = (this.userType === 'admin' || this.isManager === 'true' || sameUserLoggedIn) ? name : name.substring(0, 1);
    }
    return result;
  }
}
